import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { CUSTOMARIUS } from "../../assets";
import { useNavigate } from "react-router-dom";

function Publications() {
  const navigate = useNavigate();
  return (
    <LandingPageLayout title={<>Publications</>} currentLink="Publications">
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 py-8 sm:py-10 px-4 sm:px-8 lg:px-20 gap-4 sm:gap-5">
        {[1].map((_, index) => (
          <div
            key={index}
            onClick={() => navigate("/publication-details")}
            className="w-full h-fit border-b-[3px] rounded-b-xl border-globalGreen bg-white shadow-lg gap-y-2 sm:gap-y-3 flex flex-col items-center rounded-md p-3 sm:p-4 cursor-pointer hover:shadow-xl transition-shadow"
          >
            <img
              src={CUSTOMARIUS}
              className="w-full max-w-[190px] h-auto object-contain"
              alt="Customarius Publication"
            />
            <span className="text-globalGreen text-center text-sm sm:text-[16px] font-medium">
              Customarius
            </span>
            <span className="text-xs sm:text-sm text-gray-regular">
              Issue 8
            </span>
            <span className="text-xs sm:text-sm text-primary-300">₦2,000</span>
          </div>
        ))}
      </div>
    </LandingPageLayout>
  );
}

export default Publications;
